import styled from 'styled-components';

export const HeroSection = styled.section`
  padding: 32px 20px 24px;
  background: linear-gradient(135deg, #f5f3ff 0%, #fce7f3 100%);
  text-align: center;
  border-bottom-left-radius: 28px;
  border-bottom-right-radius: 28px;
`;

export const BadgeWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #f3e8ff;
  color: #8b5cf6;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 16px;
`;

export const HeroTitle = styled.h1`
  font-size: 26px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.25;
  margin-bottom: 12px;
`;

export const HeroDescription = styled.div`
  font-size: 15px;
  color: #64748b;
  line-height: 1.5;
  margin-bottom: 24px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
  align-items: center;
`;

export const TrialNoteText = styled.div`
  font-size: 12px;
  color: #64748b;
  margin-top: 8px;
`;
